import { useEffect, useState } from "react";
import { NODE_FIELD_BOX, NODE_FIELD_IDLE } from "./nodeStyles";

export default function NodeNumberField(props: {
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  const [displayValue, setDisplayValue] = useState(String(props.value));

  useEffect(() => {
    setDisplayValue(String(props.value));
  }, [props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    // Allow empty, digits, and single dot
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setDisplayValue(val);
      const num = val === "" ? 0 : Number(val);
      if (!isNaN(num) && num >= 0) {
        props.onChange(num);
      }
    }
  };

  const handleBlur = () => {
    // Clean up display on blur
    setDisplayValue(String(props.value || 0));
  };

  return (
    <div className="flex flex-col w-full gap-[8px] noDrag nowheel">
      <div className="font-medium text-creator-text-sub text-[14px]">
        {props.label}
      </div>
      <div
        className={
          NODE_FIELD_BOX +
          " " +
          (props.disabled
            ? "border-creator-border opacity-70"
            : NODE_FIELD_IDLE + " focus-within:border-creator-primary focus-within:shadow-[0_0_0_3px_rgba(58,196,255,0.15)]")
        }
      >
        <div className="flex items-center w-full h-full px-[8px] gap-[10px] text-creator-text-sub text-[20px]">
          <input
            type="text"
            inputMode="decimal"
            value={displayValue}
            onChange={props.disabled ? undefined : handleChange}
            onBlur={handleBlur}
            readOnly={props.disabled}
            aria-disabled={props.disabled}
            className={
              "w-full min-w-0 font-normal text-[13px] text-creator-text focus:outline-none bg-transparent " +
              (props.disabled
                ? "cursor-not-allowed text-creator-text-faded pointer-events-none select-none"
                : "")
            }
            style={{
              backgroundColor: "transparent",
              WebkitAppearance: "none",
              appearance: "none",
              boxShadow: "none",
              WebkitBoxShadow: "0 0 0 1000px transparent inset",
              WebkitTextFillColor: props.disabled
                ? "var(--pi-disabled)"
                : "var(--pi-text-color-1)",
            }}
          />
        </div>
      </div>
    </div>
  );
}
